import { BuilderElementType } from '@website-builder/model/domain/builder-element-type.enum';

import { BaseWidget } from '@website-builder/widgets/base/base-widget';
import { ToTopStyle } from '@website-builder/widgets/to-top/model/to-top-style';
import { ToTopTextStyle } from '@website-builder/widgets/to-top/model/to-top-text-style';
import { BaseWidgetNormalizer } from '@website-builder/widgets/normalizer/base-widget-normalizer';

export class ToTopWidget extends BaseWidget<ToTopStyle> {
  readonly type = BuilderElementType.ToTop;
  style = new ToTopStyle();
  hoverMessage = '';
  text: string;
  textStyle = new ToTopTextStyle();
  icon = 'mdi:chevron-up';
  disabled: boolean;

  constructor() {
    super();
  }

  static normalizeInPlace(widget: ToTopWidget): ToTopWidget {
    const pureWidget = new ToTopWidget();

    BaseWidgetNormalizer.normalizeInPlace(widget, pureWidget);

    widget.hoverMessage = widget.hoverMessage ?? pureWidget.hoverMessage;
    widget.text = widget.text ?? pureWidget.text;
    widget.icon = widget.icon ?? pureWidget.icon;
    widget.disabled = widget.disabled ?? pureWidget.disabled;

    widget.style = ToTopStyle.normalize(widget.style);
    widget.textStyle = ToTopTextStyle.normalize(widget.textStyle);

    return widget;
  }
}
